var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"formMap",staticStyle:{"height":"300px"},attrs:{"zoom":_vm.map.zoom,"center":_vm.map.center,"options":_vm.map.options,"crs":_vm.map.crs}},[_c('l-control-zoom',{attrs:{"position":"topright"}}),_c('l-tile-layer',{attrs:{"url":_vm.map.url}}),_c('l-geo-json',{attrs:{"geojson":_vm.geojson}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }